// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__3Yiu8","main":"Footer_main__1ag30","names":"Footer_names__zeVd_","commentMessage":"Footer_commentMessage__3qClI","email":"Footer_email__9joxw"};